import { defineComponent } from "../../../common/runtime/defineComponent.svelte.ts";
import type { Props } from "./SpinnerV1.types.ts";

defineComponent<Props>({
  tag: "oc-spinner-v1",
  extendOptions: { useShadow: false },
  styles: () => import("./SpinnerV1.global.scss?inline"),
  props: {
    size: { type: "String", reflect: true },
    variant: { type: "String", reflect: true },
  },
});
